import { setMessagesAsRead } from '../../actions/messages';
import { ResponseError } from '../../errors';
import {
  fetchMessagesRead,
  IMessagesReadRequest,
  TMessagesReadResponse,
} from '../../repositories/chats/v1/messages-read';
import { TThunkAction, TThunkDispatch } from '../../types/redux/thunk';

// FIXME параметра messageIds нет в ручке, но чинить это будем позже
type TMessagesReadRequest = IMessagesReadRequest & { messageIds: string[] };

/**
 * Пометить группу сообщений как прочитанные
 * @param parameters.chatId id чата
 * @param parameters.messageIds массив id сообщений
 */
export const markMessagesAsRead =
  (parameters: TMessagesReadRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const { chatId, messageIds } = parameters;

    try {
      const response: TMessagesReadResponse = await fetchMessagesRead({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      if (response.statusCode < 300) {
        dispatch(setMessagesAsRead({ chatId, messageIds }));
      } else {
        throw new ResponseError({
          domain: 'markMessagesAsRead',
          message: 'Failed to mark messages as read',
        });
      }
    } catch (ex) {
      logger.warning(ex, {
        domain: 'markMessagesAsRead',
        message: 'Failed to mark messages as read',
      });
    }
  };

let timeout: ReturnType<typeof setTimeout>;

const MARK_MESSAGE_AS_READ_TIMEOUT = 1000;

export const markMessagesAsReadWithTimeout = (parameters: TMessagesReadRequest) => (dispatch: TThunkDispatch) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    clearTimeout(timeout);
    dispatch(markMessagesAsRead(parameters));
  }, MARK_MESSAGE_AS_READ_TIMEOUT);
};
